import EventListener from './utils/EventListener.js'

  export default {
    props: {
      value: {
        type: String,
        twoWay: true
      },
      format: {
        default: 'MMMM/dd/yyyy'
      },
      disabledDaysOfWeek: {
        type: Array,
        default() {
          return []
        }
      },
      width: {
        type: String,
        default: '200px'
      }
    },
    data() {
      return {
        weekRange: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        dateRange: [],
        decadeRange: [],
        currDate: new Date,
        displayDayView: false,
        displayMouthView: false,
        displayYearView: false,
        mouthNames: [
                      'January', 'February', 'March',
                      'April', 'May', 'June',
                      'July', 'August', 'September',
                      'October', 'November', 'December'
                    ]
      }
    },
    watch: {
      currDate() {
        this.getDateRange()
      }
    },
    methods: {
        close() {
          this.displayDayView = this.displayMouthView = this.displayMouthView = false
        },
        inputClick() {
          if (this.displayMouthView || this.displayYearView) {
            this.displayDayView = false
          } else {
            this.displayDayView =  !this.displayDayView
          }
        },
        preNextDecadeClick(flag) {
          const year = this.currDate.getFullYear()
          const mouths = this.currDate.getMonth()
          const date = this.currDate.getDate()

          if (flag === 0) {
            this.currDate = new Date(year - 10, mouths, date)
          } else {
            this.currDate = new Date(year + 10, mouths, date)
          }
        },
        preNextMonthClick(flag) {
          const year = this.currDate.getFullYear()
          const month = this.currDate.getMonth()
          const date = this.currDate.getDate()


          if (flag === 0) {
            const preMonth = this.getYearMonth(year, month - 1)
            this.currDate = new Date(preMonth.year, preMonth.month, date)
          } else {
            const nextMonth = this.getYearMonth(year, month + 1)
            this.currDate = new Date(nextMonth.year, nextMonth.month, date)
          }
        },
        preNextYearClick(flag) {
          const year = this.currDate.getFullYear()
          const mouths = this.currDate.getMonth()
          const date = this.currDate.getDate()

          if (flag === 0) {
            this.currDate = new Date(year - 1, mouths, date)
          } else {
            this.currDate = new Date(year + 1, mouths, date)
          }
        },
        yearSelect(el, e) {
          e.stopPropagation()
          this.displayYearView = false
          this.displayMouthView = true
          this.currDate = new Date(el.$el.innerHTML, this.currDate.getMonth(), this.currDate.getDate())
        },
        daySelect(date, el) {
          if (el.$el.classList[0] === 'datepicker-item-disable') {
            return false
          } else {
            this.currDate = date
            this.value = this.stringify(this.currDate)
            this.displayDayView = false
          }
        },
        switchMouthView() {
          this.displayDayView = false
          this.displayMouthView = true
        },
        switchDecadeView() {
          this.displayMouthView = false
          this.displayYearView = true
        },
        mouthSelect(index) {
          this.displayMouthView = false
          this.displayDayView = true
          this.currDate = new Date(this.currDate.getFullYear(), index, this.currDate.getDate())
        },
        getYearMonth(year, month) {
            if (month > 11) {
              year++
              month = 0
            } else if (month < 0) {
              year--
              month = 11
            }
            return {year: year, month: month}
        },
        stringifyDecadeHeader(date) {
          const yearStr = date.getFullYear().toString()
          const firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0
          const lastYearOfDecade = parseInt(firstYearOfDecade, 10) + 10
          return firstYearOfDecade + '-' + lastYearOfDecade
        },
        stringifyDayHeader(date) {
          return this.mouthNames[date.getMonth()] + ' ' + date.getFullYear()
        },
        parseMouth(date) {
          return this.mouthNames[date.getMonth()]
        },
        stringifyYearHeader(date) {
          return date.getFullYear()
        },
        stringify(date, format = this.format) {
          const year = date.getFullYear()
          const month = date.getMonth() + 1
          const day = date.getDate()
          const mouthName = this.parseMouth(date)

          return format
            .replace(/yyyy/g, year)
            .replace(/MMMM/g, mouthName)
            .replace(/MMM/g, mouthName.substring(0, 3))
            .replace(/MM/g, ('0' + month).slice(-2))
            .replace(/dd/g, ('0' + day).slice(-2))
            .replace(/yy/g, year)
            .replace(/M(?!a)/g, month)
            .replace(/d/g, day)
        },
        parse(str) {
          const date = new Date(str)
          return isNaN(date.getFullYear()) ? null : date
        },
        getDayCount(year, month) {
          const dict = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

          if (month === 1) {
              if ( (year % 400 === 0) || (year % 4 === 0 && year % 100 !== 0) ) {
                  return 29
              }
              return 28
          }

          return dict[month]
        },
        getDateRange() {
            this.dateRange = []
            this.decadeRange = []
            const time = {
                year: this.currDate.getFullYear(),
                month: this.currDate.getMonth(),
                day: this.currDate.getDate()
            }
            const yearStr = time.year.toString()
            const firstYearOfDecade = (yearStr.substring(0, yearStr.length - 1) + 0) - 1
            for (let i = 0; i < 12; i++) {
              this.decadeRange.push({
                text: firstYearOfDecade + i
              })
            }

            const currMonthFirstDay = new Date(time.year, time.month, 1)
            let firstDayWeek = currMonthFirstDay.getDay() + 1
            if (firstDayWeek === 0) {
                firstDayWeek = 7
            }
            const dayCount = this.getDayCount(time.year, time.month)
            if (firstDayWeek > 1) {
              const preMonth = this.getYearMonth(time.year, time.month - 1)
              const prevMonthDayCount = this.getDayCount(preMonth.year, preMonth.month)
              for (let i = 1; i < firstDayWeek; i++) {
                  const dayText = prevMonthDayCount - firstDayWeek + i + 1
                  this.dateRange.push({
                      text: dayText,
                      date: new Date(preMonth.year, preMonth.month, dayText),
                      sclass: 'datepicker-item-gray'
                  })
              }
            }

            for (let i = 1; i <= dayCount; i++) {
                const date = new Date(time.year, time.month, i)
                const week = date.getDay()
                let sclass = ''
                this.disabledDaysOfWeek.forEach((el)=> {
                  if (week === parseInt(el, 10)) sclass = 'datepicker-item-disable'
                })

                if (i === time.day) {
                  if (this.value) {
                    const valueDate = this.parse(this.value)
                    if (valueDate) {
                      if (valueDate.getFullYear() === time.year && valueDate.getMonth() === time.month) {
                        sclass = 'datepicker-dateRange-item-active'
                      }
                    }
                  }
                }
                this.dateRange.push({
                    text: i,
                    date: date,
                    sclass: sclass
                })
            }

            if (this.dateRange.length < 42) {
                const nextMonthNeed = 42 - this.dateRange.length
                const nextMonth = this.getYearMonth(time.year, time.month + 1)

                for (let i = 1; i <= nextMonthNeed; i++) {
                    this.dateRange.push({
                        text: i,
                        date: new Date(nextMonth.year, nextMonth.month, i),
                        sclass: 'datepicker-item-gray'
                    })
                }
            }
        }
    },
    ready() {
      this.$dispatch('child-created', this)
      this.currDate = this.parse(this.value) || this.parse(new Date())
      this._closeEvent = EventListener.listen(window, 'click', (e)=> {
        if (!this.$el.contains(e.target)) this.close()
      })
    },
    beforeDestroy() {
      if (this._closeEvent) this._closeEvent.remove()
    }
  }


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/Datepicker.vue
 **/